export default "__VITE_ASSET__QZYpWcGp__"